var map = {
	"./bbc54yyk/logo.svg": 1869,
	"./chaoxinxing/logo.svg": 1873,
	"./yyk/logo.svg": 175
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/logo\.svg$
// module id = 198
// module chunks = 0